/**
 * TPM PUBLIC API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import {ValidatorFn, Validators} from "@angular/forms";

export interface BookingSlot { 
    startDate: string;
    appointmentResourceId: number;
    appointmentResourceName: string;
}
export const BookingSlot_startDate_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingSlot_appointmentResourceId_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingSlot_appointmentResourceName_Validators: ValidatorFn[] =
    [  Validators.required, ];


